// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"134":"chunk_layerswipe","150":"chunk_metadatasearch","230":"chunk_routingService","385":"chunk_featuredata","605":"chunk_timeseries","687":"chunk_metadataflyout","757":"chunk_feedbackService","832":"chunk_maprotator","855":"chunk_announcements","874":"chunk_maplegend"}[chunkId] || chunkId) + "/oskari.min.js";
};